<div class="data-sync-panel" animate.enter="panel-enter">
  <header class="panel-header">
    <mat-icon class="header-icon" [tfsIcon]="'cloud-upload'"></mat-icon>
    <span class="title-medium">Data sync</span>
  </header>

  @if (activeJobs().length > 0 || completedJobs().length > 0) {
    <ul class="job-list" role="list">
      @for (job of activeJobs(); track job.id) {
        <li class="job-row job-row-active" animate.enter="row-enter">
          <span class="row-avatar">
            <mat-icon [tfsIcon]="'headphones-2'"></mat-icon>
          </span>
          <div class="row-body">
            <span class="row-label body-medium">{{ job.label }}</span>
            <mat-progress-bar class="row-progress" mode="indeterminate" color="primary">
            </mat-progress-bar>
          </div>
        </li>
      }

      @for (job of completedJobs(); track job.id) {
        <li
          class="job-row job-row-completed"
          [class.row-success]="job.state === 'success'"
          [class.row-error]="job.state === 'error'"
          animate.enter="row-enter">
          <span class="row-avatar">
            <mat-icon [tfsIcon]="job.icon"></mat-icon>
          </span>
          <span class="row-label body-medium">{{ job.label }}</span>
          <button class="row-dismiss" type="button" aria-label="Dismiss" (click)="dismiss(job)">
            <mat-icon [tfsIcon]="'cross'"></mat-icon>
          </button>
        </li>
      }
    </ul>
  } @else {
    <p class="empty-state body-medium">No active or recent syncs.</p>
  }

  <footer class="panel-footer">
    <button mat-stroked-button type="button" [disabled]="clearAllDisabled()" (click)="clearAll()">
      Clear all
    </button>
  </footer>
</div>
